export enum EnumSalesOrganizationSettingInfoDetail {
    SEND_MAIL = '495417d0-62b9-4872-bdd7-09ac0d85eb22',
    SAVE_AND_SEND = 'ba7459e5-ff00-44b4-a085-6ce31683803a'
}
